<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <general></general>
      </v-flex>
      <v-flex xs12>
        <vehicle></vehicle>
      </v-flex>
      <v-flex xs12>
        <applicant></applicant>
      </v-flex>
      <v-flex xs12>
        <driver></driver>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE } from '@/store/types'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import General from '../query/General'
import Applicant from '../query/Applicant'
import Driver from '../query/Driver'
import Vehicle from '../query/Vehicle'

export default {
  computed: {
    motorForm() {
      return this.$store.state.agency.quotation.motorForm
    },
    commonForm() {
      return this.$store.state.agency.quotation.commonForm
    }
  },
  methods: {
    doProceed() {
      Promise.all([
        this.$store.dispatch('motorQuoteExcess', { busCls: this.motorForm.busCls, cover: this.motorForm.cover, toDefault: false }),
        this.$store.dispatch('motorQuoteAddBenefits', { busCls: this.motorForm.busCls, tariff: this.motorForm.tariff, startDate: this.commonForm.startDate })
      ])
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
      this.$router.push({ name: 'motorQuoteRefStats' })
    },
    async doPartialSave() {
      try {
        await Promise.all([
          this.$store.dispatch('motorQuoteExcess', { busCls: this.motorForm.busCls, cover: this.motorForm.cover, toDefault: false }),
          this.$store.dispatch('motorQuoteAddBenefits', { busCls: this.motorForm.busCls, tariff: this.motorForm.tariff, startDate: this.commonForm.startDate })
        ])
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 1) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
    }
  },
  components: {
    General,
    Applicant,
    Driver,
    Vehicle
  },
  mixins: [
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss">

</style>
